<template>
    <div class="min-h-screen">
        <h1 class="text-4xl font-bold text-gray-800">Module de paiement du Cavilam</h1>
        <p class="font-sans my-2 text-lg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Nulla orci libero, ullamcorper quis mauris vel, congue pharetra libero.
            Suspendisse egestas venenatis tortor sit amet consequat.
            Etiam euismod turpis nec efficitur blandit.
            Duis vitae ligula lacus. Pellentesque vitae leo vulputate,
            pellentesque felis non, venenatis turpis. Quisque id lorem tincidunt,
            fringilla neque a, cursus quam. Nam convallis eu mauris a scelerisque.
            Ut luctus orci eget sagittis aliquet. Vestibulum molestie aliquam aliquam.
        </p>
        <p class="font-sans my-2 text-lg">
            Morbi in massa lobortis, feugiat enim at, sodales odio.
            Cras varius lorem sit amet augue vehicula, non auctor tellus tempus.
            Vestibulum consequat convallis velit eu posuere.
            Proin consequat arcu eget eros rutrum, in vehicula sapien tempor.
            Fusce tincidunt nulla ut malesuada feugiat. Sed iaculis, urna a pellentesque mattis,
            neque magna vehicula augue, quis convallis urna urna sit amet dolor.
            Aliquam id tempor dolor. Donec rutrum erat ac gravida maximus. Sed eu tortor ligula.
            Nulla at justo ac nibh vulputate congue. Vestibulum nulla ligula, sodales sit amet purus
            id, dictum placerat turpis. Nunc id vehicula turpis. Quisque dapibus iaculis orci,
            ac finibus massa rhoncus at. Mauris vehicula, odio ac malesuada porta,
            elit eros elementum ipsum, auctor sagittis est orci nec metus.
            Vivamus vitae tellus vulputate, molestie tortor ac, ullamcorper lectus.
        </p>
        <!-- component -->
        <div class="row">
            <div class="w-full mx-auto">
                <inertia-link :href="route('inscription')" class="sm:grid grid-cols-4 gap-5 mx-auto px-16">
                    <div class="col-start-1 col-end-3 my-2"></div>
                    <div class="col-end-5 col-span-2 my-2">
                        <a href="#">
                            <div
                                class="h-full p-6 dark:bg-gray-800 bg-white hover:shadow-xl rounded border-b-4 border-cavilam-primary shadow-md text-right">
                                <h3 class="text-2xl mb-3 font-semibold inline-flex ">
                                    Commencer
                                    <svg class="ml-2" width="24" height="30" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M23.0677 11.9929L18.818 7.75739L17.4061 9.17398L19.2415 11.0032L0.932469 11.0012L0.932251 13.0012L19.2369 13.0032L17.4155 14.8308L18.8321 16.2426L23.0677 11.9929Z"
                                            fill="currentColor" /></svg>
                                </h3>
                                <p class="text-lg">Inscription</p>
                            </div>
                        </a>
                    </div>
                </inertia-link>
            </div>
        </div>
    </div>
</template>

<script>
import App from '@/Layouts/App'

export default {
    name: "Accueil",
    layout: App,
}
</script>

<style scoped>

</style>
